import { useEffect } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "@/hooks/translationContext";

interface SafeActionToasterProps {
    result: {
        serverError?: string;
        validationErrors?: any;
    };
    status: "idle" | "executing" | "hasSucceeded" | "hasErrored";
}

export default function SafeActionToaster({ result, status }: SafeActionToasterProps) {
    const { t } = useTranslation();
    useEffect(() => {
        switch (status) {
            case "executing":
                toast.loading(t("common-action-loading"), {
                    duration: 500,
                });
                break;

            case "hasErrored":
                if (result.serverError) {
                    toast.error(result.serverError || t("common-server-error"), {
                        duration: 4000,
                    });
                }

                if (result.validationErrors) {
                    const errorMessages = Object.values(result.validationErrors)
                        .flat()
                        .filter(Boolean);

                    errorMessages.forEach((message: any) => {
                        const errorMessage = Array.isArray(message?._errors) ? message._errors[0] : message;
                        toast.error(errorMessage, {
                            duration: 4000,
                        });
                    });
                }
                break;
        }
    }, [status, result]);

    return null;
}